// TanStack Query cache keys for admin/users, online-sessions, and roles.
export const adminUserKeys = {
  all: ["admin", "users"] as const,
  list: (params: Record<string, unknown>) =>
    ["admin", "users", "list", params] as const,
  detail: (userId: string) => ["admin", "users", userId] as const,
  profile: (userId: string) => ["admin", "users", userId, "profile"] as const,
  robotIntel: (userId: string) =>
    ["admin", "users", userId, "robot-intel"] as const,
  purchases: (userId: string, params: Record<string, unknown>) =>
    ["admin", "users", userId, "purchases", params] as const,
  tokensDetail: (userId: string, params: Record<string, unknown>) =>
    ["admin", "users", userId, "tokens-detail", params] as const,
  trades: (params: Record<string, unknown>) =>
    ["admin", "trades", params] as const,
  tradeStats: (params: Record<string, unknown>) =>
    ["admin", "trades", "stats", params] as const,
  tradeDetail: (userId: string, tradeId: string) =>
    ["admin", "users", userId, "trades", tradeId] as const,
  activity: (userId: string, params: Record<string, unknown>) =>
    ["admin", "users", userId, "activity", params] as const,
};

export const adminOnlineKeys = {
  all: ["admin", "online-sessions"] as const,
  list: (params: Record<string, unknown>) =>
    ["admin", "online-sessions", "list", params] as const,
};

export const adminRoleKeys = {
  all: ["admin", "roles"] as const,
  list: (params: Record<string, unknown>) =>
    ["admin", "roles", "list", params] as const,
};
